const NAME = 'core'

export {
  NAME
}
